var Oop = require("./oop.js");
var MessageProxyGroup = require("./messageproxygroup.js");

// TODO: domainWhiteList
function FrameProxyGroup () {

    FrameProxyGroup._parent.constructor.apply(this, arguments);
}
FrameProxyGroup.name = "FrameProxyGroup";

Oop.extend(FrameProxyGroup, MessageProxyGroup);


module.exports = FrameProxyGroup;